import axios from "axios";

export const enviarCorreo = async ({correo, valor, billetera, hash}) => {


    let data = JSON.stringify({
        "correo": correo,
        "valor": valor,
        "billetera": billetera,
        hash: hash,
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/3abb6fbf-2ced-4c70-a241-a58a7f0c7681',
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/3abb6fbf-2ced-4c70-a241-a58a7f0c7681',// test
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}